export const DEFAULT_PRICING = {
  basePrices: {
    "Regular Cleaning": [45, 50, 65, 80, 95, 110, 125, 140],
    "Deep Cleaning": [90, 110, 140, 170, 200, 240, 280, 320],
    "End of Tenancy": [120, 150, 180, 220, 260, 300, 340, 380],
    "Airbnb Cleaning": [60, 75, 95, 115, 135, 160, 185, 210],
  },
  roomExtras: {
    "Regular Cleaning": { bathroom: 10, toilet: 5 },
    "Deep Cleaning": { bathroom: 20, toilet: 10 },
    "End of Tenancy": { bathroom: 25, toilet: 10 },
    "Commercial Cleaning": { bathroom: 15, toilet: 8 },
    "Airbnb Cleaning": { bathroom: 12, toilet: 6 },
  },
  oven: { base: 50, doubleOven: 30, agaRange: 50, hob: 15, extractorFan: 10 },
  commercial: { base: 80, perExtra1000SqFt: 20 },
  discounts: { Weekly: 10, Fortnightly: 5, Monthly: 0, "One-Off": 0 },
  timeExtras: { bathroomMinutes: 30, toiletMinutes: 15 },
  laundry: { perKg: 4, ironingItem: 2, duvet: 18, suitDryClean: 15 },
  carpet: { room: 30, livingRoom: 40, stairsHallway: 35, stainProtection: 20 },
};

export const CARPET_SERVICE = "Carpet Cleaning";

export const LAUNDRY_SERVICE = "Laundry & Ironing";

const fmt = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (!m) return `${h}h`;
  return h ? `${h}h ${m}m` : `${m}m`;
};

// Shifts a "2-3 hours" / "6+ hours" range by extra minutes.
export function addMinutesToDuration(duration, extraMinutes) {
  if (!extraMinutes) return duration;
  const range = duration.match(/^(\d+)-(\d+) hours$/);
  if (range) return `${fmt(range[1] * 60 + extraMinutes)} - ${fmt(range[2] * 60 + extraMinutes)}`;
  const open = duration.match(/^(\d+)\+ hours$/);
  if (open) return `${fmt(open[1] * 60 + extraMinutes)}+`;
  return duration;
}
